import { useEffect } from 'react';
import { ENV } from '@/constants';

type TProps = {
  title?: string;
}

const useDocumentTitle = (props?: TProps) => {

  const title = props?.title;

  useEffect(
    () => {
      const environmentName = (
        ENV.name === 'development'
          ? 'DEV'
          : ENV.name === 'staging'
            ? 'STAGING'
            : undefined
      );

      let documentTitle = (
        [environmentName, 'Heyama']
          .filter(l => !!l)
          .join(' | ')
      );

      documentTitle = (
        [documentTitle, title]
          .filter(l => !!l)
          .join(' • ')
      );

      document.title = documentTitle;
    },
    [title]
  );

};

export default useDocumentTitle;
